import React, { useMemo } from "react";
import classNames from "classnames";
import DropdownMenu from "../../theme/untitled/DropdownMenu/DropdownMenu";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "./MembersPage.module.scss";

// Role/Status toolbar filters: a DropdownMenu with a checkmark against the
// active option, composed on top of DropdownMenu's flat item list since it
// has no built-in radio-group primitive.
const FilterDropdown = ({ label, value, options, onChange, mobileFull }) => {
  const activeLabel = options.find((o) => o.value === value)?.label || "All";

  const items = useMemo(
    () =>
      options.map((option) => ({
        key: option.value,
        label: option.label,
        icon:
          option.value === value ? (
            <Icon name="Check" size={20} className={styles.menuCheck} />
          ) : (
            <span className={styles.menuCheckSpacer} aria-hidden="true" />
          ),
        onClick: () => onChange(option.value),
      })),
    [options, value, onChange]
  );

  const trigger = (
    <button
      type="button"
      className={classNames(styles.filterButton, {
        [styles["filterButton--applied"]]: value !== "all",
      })}
    >
      {label}: <strong>{activeLabel}</strong>
      <Icon name="ChevronDown" size={16} className={styles.filterButtonIcon} />
    </button>
  );

  return (
    <div className={classNames(mobileFull && styles.filterButtonWrap)}>
      <DropdownMenu trigger={trigger} items={items} align="start" />
    </div>
  );
};

export default FilterDropdown;
